/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-03-11 16:11:07
 *
 *******************************************************/
// @flow

import React from 'react';
export function ThemeIcon(props) {
  return (
    <svg viewBox="0 0 20 20" focusable="false" aria-hidden="true">
      <path d="M17.5 1h-3.5v6h5v-4.5a1.5 1.5 0 0 0-1.5-1.5zm1.5 8h-5v10h3.5a1.5 1.5 0 0 0 1.5-1.5v-8.5zm-18 5h11v5h-9.5a1.5 1.5 0 0 1-1.5-1.5v-3.5zm1.5-13a1.5 1.5 0 0 0-1.5 1.5v9.5h11v-11h-9.5z"></path>
    </svg>
  );
}
